import { useState } from "react";
import styles from "./styles.module.scss";
import { CategoriesList } from "../../types";
import { Checkbox } from "antd";

export const Categories: React.FC<CategoriesList> = ({ cats, setCat }) => {
  const [categories, setCategories] = useState<string[]>(cats);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const chunkArray = (array: string[], size: number): string[][] => {
    const chunks: string[][] = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  };

  const categoryChunks = chunkArray(categories, 7);

  const handleAddCategory = (category: string) => {
    if (!categories.includes(category)) {
      setCategories((prev) => [...prev, category]);
    }
    setDropdownOpen(false);
  };

  return (
    <div className={styles.cats}>
      <div className={styles.catsWrapper}>
        {categoryChunks.map((chunk) => (
          <div key={chunk.join("|")} className={styles.catColumn}>
            {chunk.map((category) => (
              <div key={category} className={styles.catItem}>
                <Checkbox id={`category-${category}`}>
                  <span className={styles.checkboxLabel}>{category}</span>
                </Checkbox>
              </div>
            ))}
          </div>
        ))}
      </div>

      <div className={styles.inptWrapper}>
        <button
          type="button"
          className={styles.dropdown}
          onClick={() => setDropdownOpen((open) => !open)}
        >
          <span>Select an option</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.814779 2.44434C0.364789 1.99435 0.364789 1.26477 0.814779 0.814779C1.26477 0.364789 1.99435 0.364789 2.44434 0.814779L5.17778 3.54823C5.63188 4.00232 6.36812 4.00232 6.82222 3.54823L9.55566 0.814779C10.0057 0.364789 10.7352 0.364789 11.1852 0.814779C11.6352 1.26477 11.6352 1.99435 11.1852 2.44434L6.82222 6.80734C6.36812 7.26144 5.63188 7.26144 5.17778 6.80734L0.814779 2.44434Z"
              fill="white"
            />
          </svg>
        </button>

        {dropdownOpen && (
          <div className={styles.dropdownMenu}>
            {["Option 1", "Option 2"].map((option) => (
              <button
                key={option}
                type="button"
                className={styles.dropdownItem}
                onClick={() => handleAddCategory(option)}
              >
                {option}
              </button>
            ))}
          </div>
        )}
      </div>

      <button
        type="button"
        className={styles.select}
        onClick={() => setCat(false)}
      >
        Select
      </button>
    </div>
  );
};
